import { __decorate } from "tslib";
import { singleton, Syringe } from 'mana-syringe';
export var SceneGraphSelectorFactory = Syringe.defineToken('SceneGraphSelectorFactory');
export var SceneGraphSelector = Syringe.defineToken('SceneGraphSelector', {
  multiple: false
});
/**
 * support following DOM API
 * * getElementById
 * * getElementsByClassName
 * * getElementsByName
 * * getElementsByTag
 */

var DefaultSceneGraphSelector =
/** @class */
function () {
  function DefaultSceneGraphSelector() {}

  DefaultSceneGraphSelector.prototype.selectOne = function (query, root) {
    if (query.startsWith('#')) {
      // getElementById('id')
      return root.find(function (node) {
        // return !node.shadow && node.id === query.substring(1);
        return node.id === query.substring(1);
      });
    }

    return null;
  };

  DefaultSceneGraphSelector.prototype.selectAll = function (query, root) {
    // TODO: only support `[name="${name}"]` `.className`
    if (query.startsWith('.')) {
      // getElementsByClassName('className');
      // TODO: should include itself?
      return root.findAll(function (node) {
        return node.className === query.substring(1);
      });
    } else if (query.startsWith('#')) {
      return root.findAll(function (node) {
        return node.id === query.substring(1);
      });
    } else if (query.startsWith('[name=')) {
      // getElementsByName();
      return root.findAll(function (node) {
        return node.name === query.substring(7, query.length - 2);
      });
    } else {
      // getElementsByTag('circle');
      return root.findAll(function (node) {
        return node.nodeName === query;
      });
    }
  }; // eslint-disable-next-line @typescript-eslint/no-unused-vars


  DefaultSceneGraphSelector.prototype.is = function () {
    // TODO: need a simple `matches` implementation
    return true;
  };

  DefaultSceneGraphSelector = __decorate([singleton({
    token: SceneGraphSelector
  })], DefaultSceneGraphSelector);
  return DefaultSceneGraphSelector;
}();

export { DefaultSceneGraphSelector };